import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Config } from 'containers/AppContainer/typings';
import { Expertise } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import judgementFormMessages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import ExpertiseRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/ExpertiseRecap';
import { uniqueId } from 'lodash';

export interface ExpertiseRecapProps {
  intl: IntlShape;
  expertiseList: Config[];
  expertises: Expertise[];
  shouldDisplay?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
}

const ExpertisesRecap: React.FC<ExpertiseRecapProps> = (props): JSX.Element => {
  const { expertises } = props;

  return (
    <section className="expertises">
      <div className="expertise-bloc-title">
        {translate(judgementFormMessages.expertisesSectionTitle, props)}
      </div>
      {expertises.map((expertise, index: number) => (
        <ExpertiseRecap
          key={uniqueId('single-expertise')}
          expertiseList={props.expertiseList}
          index={index}
          expertise={expertise}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          isBasicManagement={props.isBasicManagement}
        />
      ))}
    </section>
  );
};

ExpertisesRecap.defaultProps = {
  shouldDisplay: true,
};

export default injectIntl(ExpertisesRecap);
